import { isStaleChunkError } from './chunkError';
import { clearSuccessfulChunkRecovery, recoverFromStaleChunk } from './chunkUpdateRecovery';
import { shouldUseServiceWorker } from './serviceWorker';

export const installChunkErrorHandler = () => {
  const handleError = (event: ErrorEvent) => {
    if (!shouldUseServiceWorker() || !isStaleChunkError(event.error ?? event.message)) return;
    event.preventDefault();
    void recoverFromStaleChunk();
  };

  const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
    if (!shouldUseServiceWorker() || !isStaleChunkError(event.reason)) return;
    event.preventDefault();
    void recoverFromStaleChunk();
  };

  const handleVitePreloadError = (event: Event) => {
    const preloadEvent = event as Event & { payload?: unknown };
    if (!shouldUseServiceWorker() || !isStaleChunkError(preloadEvent.payload)) return;
    event.preventDefault();
    void recoverFromStaleChunk();
  };

  clearSuccessfulChunkRecovery();
  window.addEventListener('error', handleError);
  window.addEventListener('unhandledrejection', handleUnhandledRejection);
  window.addEventListener('vite:preloadError', handleVitePreloadError);

  return () => {
    window.removeEventListener('error', handleError);
    window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    window.removeEventListener('vite:preloadError', handleVitePreloadError);
  };
};
